import * as api from '../../api'

const state = {}

const getters = {}

const actions = {
  uploadImportFile ({ commit }, fileImport) {
    let formData = new FormData()
    formData.append('import_type', fileImport.type)
    formData.append('import_file', fileImport.file)

    api.instance.post('file_import', formData, { 'content-type': 'multipart/form-data' })
      .then(function (response) {
        if (response.data.success === 'true') {
          alert('File successfully imported!')
        } else {
          alert(response.data.message)
        }
      })
  }
}

const mutations = {}

export default {
  state,
  getters,
  actions,
  mutations
}
